import './Logo.css';

function Logo() {
    return <div className="bg-white">
        <img className="h-100" src="https://assets.cyberprotect.cloud/v2/Logo_Cyberprotect_black_nobg_L.png" alt="Cyberprotect"></img>
    </div>
}

export default Logo;